const pagination = (array, page_size, page_number) => (array?.slice((page_number -1) * page_size, (page_number -1) * page_size + page_size));

export {
  pagination
}